import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { ClientAccountStore, TreasuredAssetsStore } from "../../../../../Stroes/Variable";
import { PPToProducErrorMessage, PPToProductLables } from "../../Resource/Contents";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { IsaAllowanceOverview } from "../../../../Clients/PortfolioDashboard/Components/ProductOverview/Component/IsaAllowanceOverview";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { Action } from "../../../../../Actions/Action";
import { SubAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";
import { isTaxRelifAvailable as isTaxReliefAvailable } from "../../../NewQuoteWizard/Components/Shared/Utils";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { ProductAllocation } from "../../../../../../../Wrap/Models/Domains/Transfer/Gia/ProductAllocation";
import { AssetsToSellFromPP } from "../../Store/PPToProductInstructionStatic";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ChooseAssetsToSell } from "./ChooseAssetsToSell";
import { ChooseAssetsToSellTable } from "./ChooseAssetsToSellTable";
import { PPToProductAction } from "../../Actions/PPToProductActions";
import { PPtoProductBuyAllocation } from "./PPtoProductBuyAllocation";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { AccountStatus } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { BedAndProductWrapperInstructionModel } from "../../../../../../../Wrap/Models/Domains/BedAndProductWrapper/BedAndProductWrapperInstructionModel";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { IsaContents } from "../../../Common/ISA/Resource/Contents";

interface IInvestmentDetailsProps extends IProcessComponentProps {
    data: any;
    isEdit?: boolean;
    customerId?: number;
    clientAccount: ClientAccount;
    onAssetChange: (v: any) => void;
    ToAbrdnSIPP: boolean;
}

interface IInvestmentDetailsState {
    disableJourney: boolean;
    transfertoAccountType: SubAccountType;
    extraInfo: {
        hasCashIsa: boolean;
        treasuredAssetsInstructionId: number;
    };
    fromAccount: SubAccount;
    toAccount: SubAccount;
    bedProductAmount: number;
    withDrawMethod: string;
    assets: AssetsToSellFromPP[];
    assetsToBuy: AssetsToSellFromPP[];
    targetAllocations: AssetsToSellFromPP[];
    sourceSubAccounts: SubAccount[];
    clientAccount: ClientAccount;
    destinationSubAccounts: SubAccount[];
    isLoading: boolean;
    treasuredAssetProductIds: Array<number>;
    isRemainingAllowanceChecked: boolean;
    remainingAllowance: number;
    isTaxReliefAvailable: boolean;
    taxYearStartDate: Date;
    taxYearEndDate: Date;
    ppToIsaSelfAmount: number;
}

export class InvestmentDetails extends ProcessComponent<IInvestmentDetailsProps, IInvestmentDetailsState> {
    public static defaultProps = {
        autoLineCompleted: true,
    };
    constructor(props: any) {
        super(props);
        this.state = {
            disableJourney: false,
            transfertoAccountType: null,
            extraInfo: {
                hasCashIsa: false,
                treasuredAssetsInstructionId: null,
            },
            fromAccount: null,
            toAccount: null,
            bedProductAmount: this.props.data?.Contribution?.BedAndProductWrapperInstruction?.BedAndProductAmount?.Amount ?? 0,
            withDrawMethod: null,
            assets: [],
            assetsToBuy: [],
            targetAllocations: [],
            sourceSubAccounts: [],
            clientAccount: null,
            destinationSubAccounts: [],
            isLoading: false,
            treasuredAssetProductIds: null,
            isRemainingAllowanceChecked: true,
            remainingAllowance: 0,
            isTaxReliefAvailable: false,
            taxYearStartDate: new Date(),
            taxYearEndDate: new Date(),
            ppToIsaSelfAmount: 0
        };   
        this.updateRemainingAllowance = this.updateRemainingAllowance.bind(this);    
    }

    public isValid(): boolean {
        const { data } = this.props;
        let estimatedTotal = 0;
        let isValidAmount = false;
        let isValidAllowarance = true;
        
        if (this.state.assets.length > 0) {
            estimatedTotal = this.state.assets
            .map((x) => x.MarketValue?.Amount ?? 0)
            .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        }
        isValidAmount = this.state.bedProductAmount <= estimatedTotal;
        if (!isValidAmount) {
                this.props.showErrorMsgPopUp(
                    ["You have entered a value greater than the products total holding value."],
                    true
                );
        }

        const destinationSubAccount = this.state.destinationSubAccounts.find((x) =>
            x.HierarchyId ==
            this.props.data.Contribution?.BedAndProductWrapperInstruction?.ToHierarchyId?.HierarchyIdString
        );
        const accountType = destinationSubAccount?.SubAccountType ?? this.state.transfertoAccountType;   
        if(accountType == SubAccountType.StocksIsa){
            isValidAllowarance = this.state.remainingAllowance > 0
            if(!isValidAllowarance){
                const startYearStr = JsonDateParser.getFormatDate(this.state.taxYearStartDate, "yyyy");
                const endYearStr = JsonDateParser.getFormatDate(this.state.taxYearEndDate, "yyyy");
                this.props.showErrorMsgPopUp(
                    [`ISA Stocks & Shares ${destinationSubAccount?.ClAccountId} has used all of their remaining ${startYearStr}/${endYearStr} Tax Year's subscription. Therefore this transfer can only take place at the start of the next Tax Year`],
                    true
                );
            }
        }
        return super.isValid() && isValidAmount && isValidAllowarance;
    }

    componentDidMount(): void {
        this.getTreasuredAssets();
        const subAccountInstructionId = HierarchyIdHelper.generateHierarchyId(this.props.data.HierarchyId).entityId;
        Action.getInstructionTreasuredAssetsProductIds(subAccountInstructionId);
        if (this.props.data.Contribution?.BedAndProductWrapperInstruction?.FromHierarchyId) {
            var subAccountHierarchyId = this.props.data.Contribution.BedAndProductWrapperInstruction.FromHierarchyId
                .HierarchyIdString;
            this.getSellableHoldings(subAccountHierarchyId, true);
        }
        if (this.props.data.Contribution?.BedAndProductWrapperInstruction?.ToHierarchyId) {
            var subAccountHierarchyId = this.props.data.Contribution.BedAndProductWrapperInstruction.ToHierarchyId
                .HierarchyIdString;
            this.getSellableHoldings(subAccountHierarchyId, false);
        }
        const clientAccount = ClientAccountStore.getClientAccountInfo();

        const ppAccounts = clientAccount.SubAccounts.filter(
            (x) => x.Status == AccountStatus.Active && x.SubAccountType == SubAccountType.InvestmentAccount
        );
        
        const selected = this.props.data.Contribution?.BedAndProductWrapperInstruction?.FromHierarchyId?.HierarchyIdString
            ? ppAccounts.find(
                (x) => x.HierarchyId == this.props.data.Contribution?.BedAndProductWrapperInstruction?.FromHierarchyId?.HierarchyIdString
            ) : ppAccounts[0];

        if (this.props.data.Contribution?.BedAndProductWrapperInstruction?.FromHierarchyId == null || this.props.data.Contribution?.BedAndProductWrapperInstruction?.ToHierarchyId) {
            
            var defaultFrom = null;
            var defaultTo = null;

            if (selected && selected.HierarchyId) {
                defaultFrom = this.generateBackendHierarchyId(selected.HierarchyId);
            }

            const transferToAccounts = this.getTransferToAccounts(clientAccount, this.props.ToAbrdnSIPP);
            if (transferToAccounts.length === 1) {
                defaultTo = this.generateBackendHierarchyId(transferToAccounts[0].HierarchyId);
            }
            if (defaultFrom || defaultTo) {
                this.onDataChange(
                    (changes) => this.onDataChange(this.props.onChange, changes, this.props.data, "Contribution"),
                    {
                        FromHierarchyId: defaultFrom,
                        ToHierarchyId: defaultTo
                    },
                    this.props.data.Contribution,
                    "BedAndProductWrapperInstruction"
                );
            }
            
            if (defaultTo) {
                this.getTransferToAccountAllocations(defaultTo.HierarchyIdString);
            }
        }
        

        isTaxReliefAvailable(this.props.data?.ClientDetails?.DateOfBirth, new Date())
            .then(value => this.setState({isTaxReliefAvailable: value}))
      
        this.getAvailablePPAccountsForDropDown(ppAccounts, selected?.HierarchyId, !!selected);
        
    }

    updateRemainingAllowance(amount: number,startYear: Date,endYear: Date) {           
            const { destinationSubAccounts, transfertoAccountType } = this.state;
            const destinationSubAccount = destinationSubAccounts.find((x) =>
                x.HierarchyId ==
                this.props.data.Contribution?.BedAndProductWrapperInstruction?.ToHierarchyId?.HierarchyIdString
            );
            const accountType = destinationSubAccount?.SubAccountType ?? transfertoAccountType;           
            if (accountType == SubAccountType.StocksIsa){
                this.setState({ 
                    remainingAllowance: amount,
                    taxYearStartDate: startYear,
                    taxYearEndDate: endYear
                });
                this.onChangeBedProductAmount(amount)
            }      
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    handleAssetChange = (data) => {
        this.props.onAssetChange(this.adjustAssets(data));
    };

    private adjustAssets(assets) {
        const totalAmount = assets.reduce((total, asset) => total + asset.MarketValue.Amount, 0);
        let adjustedAssets = assets.map((asset) => ({
            Name: asset.AssetName,
            Percentage: Math.round((asset.MarketValue.Amount / totalAmount) * 10000) / 100,
            ProductId: asset.ProductId,
            Type: asset.ProductType,
        }));
        let totalPercentage = adjustedAssets.reduce((sum, asset) => sum + asset.Percentage, 0);
        let remainder = 100 - totalPercentage;
        let minPercentageAssetIndex = adjustedAssets.findIndex(
            (asset) => asset.Percentage === Math.min(...adjustedAssets.map((asset) => asset.Percentage))
        );
        adjustedAssets[minPercentageAssetIndex].Percentage = +(
            adjustedAssets[minPercentageAssetIndex].Percentage + remainder
        ).toFixed(2);
        totalPercentage = adjustedAssets.reduce((sum, asset) => sum + asset.Percentage, 0);
        if (totalPercentage !== 100) {
            let diff = 100 - totalPercentage;
            adjustedAssets[minPercentageAssetIndex].Percentage = +(
                adjustedAssets[minPercentageAssetIndex].Percentage + diff
            ).toFixed(2);
        }
        return adjustedAssets;
    }

    onChangeRemainingAllowance(check: any) {
        this.setState({ isRemainingAllowanceChecked: check })
        const { remainingAllowance } = this.state
        let amount = 0;
        if (check) {
            amount = remainingAllowance;
        }
        this.onChangeBedProductAmount(amount)
    }

    onChangeBedProductAmount(changes: number) {       
        this.onDataChange(
            (changes) => this.onDataChange(this.props.onChange, changes, this.props.data, "Contribution"),
            { BedProductAmount: { Amount: changes, Currency: CurrencyCode.GBP } },
            this.props.data.Contribution,
            "BedAndProductWrapperInstruction"
        );
        
        this.setState({ bedProductAmount: changes, ppToIsaSelfAmount:  (this.state.isRemainingAllowanceChecked || changes > this.state.remainingAllowance) ? 0 : changes });
    }

    onChangeSellInvestmentSelection(changes: any) {
        this.onDataChange(this.props.onChange, changes, this.props.data);
        if (changes.Contribution?.InstrumentSelections?.Instruments) {
            const productAllocationArray: ProductAllocation[] = [];
            changes.Contribution?.InstrumentSelections?.Instruments?.forEach((ele) => {
                const productAllocation: ProductAllocation = {
                    ProductId: ele.Instrument.ProductId,
                    Percentage: ele.allocation,
                    Value: { Amount: (this.state.bedProductAmount * ele.allocation) / 100, Currency: CurrencyCode.GBP },
                };
                productAllocationArray.push(productAllocation);
            });
            this.onDataChange(
                (changes) => this.onDataChange(this.props.onChange, changes, this.props.data, "Contribution"),
                { SellAllocations: productAllocationArray },
                this.props.data.Contribution,
                "BedAndProductWrapperInstruction"
            );
        }
    }

    private getSellableHoldings = (subAccountHierarchyId: string, isPP: boolean) => {
        const hierarchyId = getQueryParameters()["hierarchyid"];
        this.setState({ isLoading: true }, () => {
            PPToProductAction.getSellableAssets(
                SubAccountType.PersonalPortfolio,
                hierarchyId,
                subAccountHierarchyId,
                (data) => {
                    if (isPP) {
                        this.setState({
                            assets: data.currentAssets,
                            assetsToBuy: data.currentAssets,
                            isLoading: false,
                        });
                        if (!this.props.data?.Contribution?.BedAndProductWrapperInstruction?.SellAllocations) {
                            this.handleAssetChange(data.currentAssets);
                        }
                    } else {
                        this.setState({
                            assetsToBuy: data.currentAssets,
                            targetAllocations: data.targetAllocations,
                            isLoading: false,
                        });
                    }
                }
            );
        });
    };

    private getTransferToAccountAllocations(subAccountHierarchyId: string) {
        this.getSellableHoldings(subAccountHierarchyId, false);
    }

    private getAvailablePPAccountsForDropDown = (subAccounts: SubAccount[],
        subAccountHierarchyId: string | undefined, isSelected: boolean) => {
        const hierarchyId = getQueryParameters()["hierarchyid"];
        subAccounts.forEach((sa,index) => {
            this.setState({ isLoading: true }, () => {
                PPToProductAction.getSellableAssets(
                    SubAccountType.PersonalPortfolio,
                    hierarchyId,
                    sa.HierarchyId,
                    (data) => {
                        let estimatedTotal = 0;
                        let cashAvailable = 0;

                        if (data.currentAssets.length > 0) {
                            estimatedTotal = data.currentAssets
                                .map((x) => x.MarketValue?.Amount ?? 0)
                                .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

                            cashAvailable = data.currentAssets
                                .filter((x) => x.ProductType == ProductType.Cash)
                                .map((x) => x.MarketValue?.Amount ?? 0)
                                .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                        }

                        if (estimatedTotal > 0 || cashAvailable > 0) {
                            this.state.sourceSubAccounts.push(sa);
                            this.setState({
                                sourceSubAccounts: this.state.sourceSubAccounts,
                                isLoading: false,
                            });
                            if (isSelected && subAccountHierarchyId && sa.HierarchyId == subAccountHierarchyId) {
                                this.setState({
                                    assets: data.currentAssets,
                                    assetsToBuy: data.currentAssets,
                                    isLoading: false,
                                });
                                if (!this.props.data?.Contribution?.BedAndProductWrapperInstruction?.SellAllocations) {
                                    this.handleAssetChange(data.currentAssets);
                                }
                            }
                        } else {
                            this.setState({ isLoading: false });
                        }
                        if(subAccounts.length === index + 1 && this.state.sourceSubAccounts.length === 1){
                            this.getSelectedPPaccount();
                        }
                    }
                );
            });
        });
       
    };

    private generateBackendHierarchyId(hierarchyId: string) {
        let result = null;
        if (hierarchyId) {
            var hierarchyEntity = HierarchyIdHelper.generateHierarchyId(hierarchyId);
            if (hierarchyEntity) {
                result = {
                    Type: hierarchyEntity.hierarchyLevel,
                    EntityId: hierarchyEntity.entityId,
                    HierarchyIdString: hierarchyId,
                };
            }
        }
        return result;
    }

    private onTreasuredAssetChange = (v: boolean, productId: number) => {
        const treasuredAssets = new Set(this.state.treasuredAssetProductIds);
        let stateHasChanged = false;

        if (treasuredAssets.has(productId)) {
            if (!v) {
                treasuredAssets.delete(productId);
                stateHasChanged = true;
            }
        } else {
            if (v) {
                treasuredAssets.add(productId);
                stateHasChanged = true;
            }
        }

        if (stateHasChanged) {
            this.setState({ treasuredAssetProductIds: Array.from(treasuredAssets) });
        }
    };

    private getTreasuredAssets() {
        const _treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();

        if (!_treasuredAssetProductIds) {
            const params = getQueryParameters();

            Action.getSubAccountTreasuredAssetsProductIds(params["subaccounthierarchyid"], (data: Array<number>) => {
                this.setState({ treasuredAssetProductIds: data });
            });
        } else {
            this.setState({ treasuredAssetProductIds: _treasuredAssetProductIds });
        }
    }

    public render(): JSX.Element {
        const { Contribution } = this.props.data;
        const { sourceSubAccounts, destinationSubAccounts } = this.state;

        return (
            <div>
                {Contribution?.AdviceGiven && 
                   ((destinationSubAccounts.length == 0 &&
                    <div className="mb-32">
                        <Alert
                            alertType={AlertType.Error}
                            message={
                                this.props.ToAbrdnSIPP ? PPToProducErrorMessage.toSipp : PPToProducErrorMessage.toIsa
                            }
                        />

                        <button
                            className="btn secondary"
                            onClick={() =>
                                window.location.assign(
                                    "/wpadviser/en-gb/dashboard/home/main/client/new-business/full-client-detail?customerid=" +
                                    this.props.data.ClientDetails.ActorId +
                                    "&hierarchyid=" +
                                    this.props.data.OwnerHierarchyId
                                )
                            }
                        >
                            New product
                        </button>
                    </div>) ||
                    (sourceSubAccounts.length == 0 && (
                        <div className="mb-32">
                        <Alert
                            alertType={AlertType.Error}
                            message={ PPToProducErrorMessage.noSellableHolding }
                        />
                        </div>)
                    ))
                }

                <h2>Investment details</h2>
                <FinancialAdvice
                    {...this.getProps("Contribution")}
                    readonly={this.state.disableJourney}
                    processtype={ProcessType.PPToProduct}
                />
                {Contribution?.AdviceGiven != null && this.renderInvestmentDetails()}
            </div>
        );
    }

    private getTransferToAccounts(clientAccount: ClientAccount, toabrdnsipp: boolean) {
        const transferToAccounts = clientAccount.SubAccounts.filter(
            (x) =>
                x.Status == AccountStatus.Active &&
                (toabrdnsipp ? x.SubAccountType == SubAccountType.Npr : x.SubAccountType == SubAccountType.StocksIsa)
        ).sort((a, b) => {
            if (a?.ClAccountId < b?.ClAccountId) {
                return 1;
            }
            if (a?.ClAccountId > b?.ClAccountId) {
                return -1;
            }
            return 0;
        });

        this.setState({ destinationSubAccounts: transferToAccounts });

        return transferToAccounts;
    }

    private onDestinationSubAccountChange(subAccount: SubAccount) {
        this.onDataChange(
            (subAccount) =>
                this.onDataChange(
                    this.props.onChange,
                    subAccount,
                    this.props.data,
                    "Contribution"
                ),
            { ToHierarchyId: this.generateBackendHierarchyId(subAccount?.HierarchyId) },
            this.props.data.Contribution,
            "BedAndProductWrapperInstruction"
        );
        if (subAccount && subAccount.HierarchyId) {
            this.getSellableHoldings(subAccount.HierarchyId, false);
            Action.getSubAccountTreasuredAssetsProductIds(
                subAccount.HierarchyId,
                (data: Array<number>) => {
                    this.setState({ treasuredAssetProductIds: data });
                }
            );
        }
        this.setState({ transfertoAccountType: subAccount?.SubAccountType });
    }

    private onSourceSubAccountChange(subAccount: SubAccount) {
        this.onDataChange(
            (subAccount) =>
                this.onDataChange(
                    this.props.onChange,
                    subAccount,
                    this.props.data,
                    "Contribution"
                ),
            { FromHierarchyId: this.generateBackendHierarchyId(subAccount?.HierarchyId) },
            this.props.data.Contribution,
            "BedAndProductWrapperInstruction"
        );
        if (subAccount && subAccount.HierarchyId) {
            this.getSellableHoldings(subAccount.HierarchyId, true);
        }
    }

    private getSelectedPPaccount(){
        const { sourceSubAccounts} = this.state;
        
            var selected= sourceSubAccounts[0];
            var defaultFrom = this.generateBackendHierarchyId(selected.HierarchyId);
            this.onDataChange(
                (changes) => this.onDataChange(this.props.onChange, changes, this.props.data, "Contribution"),
                defaultFrom,
                this.props.data.Contribution.BedAndProductWrapperInstruction,
                "FromHierarchyId"
            );
            
    }

    private renderInvestmentDetails() {
        const { data, onChange } = this.props;
        const { sourceSubAccounts, destinationSubAccounts, isRemainingAllowanceChecked, remainingAllowance } = this.state;
        const clientAccount = ClientAccountStore.getClientAccountInfo();

        const destinationSubAccount = destinationSubAccounts.find((x) =>
            x.HierarchyId ==
            data.Contribution?.BedAndProductWrapperInstruction?.ToHierarchyId?.HierarchyIdString
        );
        const transfertoAccountType = destinationSubAccount?.SubAccountType ?? this.state.transfertoAccountType;
        const modelData: typeof data.Contribution = JSON.parse(JSON.stringify(data?.Contribution));
       
        let tableConfig = [];
        let estimatedTotal = 0;
        let cashAvailable = 0;

        if (this.state.assets.length > 0) {
            estimatedTotal = this.state.assets
                .map((x) => x.MarketValue?.Amount ?? 0)
                .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

            cashAvailable = this.state.assets
                .filter((x) => x.ProductType == ProductType.Cash)
                .map((x) => x.MarketValue?.Amount ?? 0)
                .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        }

        tableConfig.push({
            title: "Estimated value",
            data: MoneyDisplayHelper.FromatMoneyDisplay(estimatedTotal, CurrencyCode.GBP),
        });
        tableConfig.push({
            title: "Cash available",
            data: MoneyDisplayHelper.FromatMoneyDisplay(cashAvailable, CurrencyCode.GBP),
        });
        tableConfig.push({
            title: "Estimated asset value available",
            data: MoneyDisplayHelper.FromatMoneyDisplay(estimatedTotal - cashAvailable, CurrencyCode.GBP),
        });

        return (
            <>
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <SelectEditor
                            options={sourceSubAccounts}
                            getText={(v) => {
                                return v.ProductDisplayName + " " + v.ClAccountId;
                            }}
                            onChange={(newSourceSubAccount) => this.onSourceSubAccountChange(newSourceSubAccount)}
                            selected={sourceSubAccounts.find(
                                (x) => x.HierarchyId == data.Contribution?.BedAndProductWrapperInstruction?.FromHierarchyId?.HierarchyIdString)
                            }
                            disabled={sourceSubAccounts.length === 1}
                            label="Personal Portfolio"
                            required="Please select"
                            placeholder="Please select"
                        />
                    </div>
                </div>
                {(data.Contribution.BedAndProductWrapperInstruction?.FromHierarchyId) && (
                    <PartLoading isLoading={this.state.isLoading}>
                        <Typography type="common" wrapCss="text-bold" config={tableConfig} />
                    </PartLoading>
                )}
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <SelectEditor
                            options={destinationSubAccounts}
                            selected={destinationSubAccount}
                            getText={(v) => v.ProductDisplayName + " " + v.ClAccountId}
                            onChange={(newDestinationsubAccount) => this.onDestinationSubAccountChange(newDestinationsubAccount)}
                            label={PPToProductLables.transferTo}
                            disabled={destinationSubAccounts.length === 1}
                            required="Please select"
                            placeholder="Please select"
                        />
                    </div>
                </div>

                {transfertoAccountType == SubAccountType.StocksIsa &&
                    <CheckboxEditor                       
                        value={isRemainingAllowanceChecked}
                        onChange={(check) => { this.onChangeRemainingAllowance(check) }}
                        label="Use remaining ISA allowance"
                        cssWrapper="square-checkbox block"
                    />
                }
                {
                    <NumberTextBoxEditor
                        label={PPToProductLables.transferSippAmount}
                        cssWrapper="control-size-430"
                        value={data?.Contribution?.BedAndProductWrapperInstruction?.BedProductAmount?.Amount ?? 0}
                        onChange={(changes) => this.onChangeBedProductAmount(changes)}
                        maxNumberOfDecimalPlaces={{
                            errorMessage: "only allow two decimal places",
                            value: 2,
                        }}
                        moreThan={{
                            value: 0,
                            errorMessage: "Value must larger than 0",
                        }}
                        atLeast={{ value: 0, errorMessage: "Bed & ISA Amount entered must be > 0" }}
                        atMost={{
                            errorMessage: null,
                            value:this.state.remainingAllowance
                        }}
                        required="Please enter"
                        disabled={isRemainingAllowanceChecked && transfertoAccountType == SubAccountType.StocksIsa}
                    />
                }
                {transfertoAccountType == SubAccountType.StocksIsa && clientAccount != null && (
                    <>
                        {this.state.remainingAllowance < this.state.bedProductAmount && (<Alert alertType={AlertType.Error} message={IsaContents.Error_ExceedIsaAllowance} />)}
                        <IsaAllowanceOverview headaccount={clientAccount} bedProductAmount={this.state.ppToIsaSelfAmount} updateRemainingAllowance = {this.updateRemainingAllowance}/>
                    </>
                )}
                {transfertoAccountType == SubAccountType.Npr && (
                    <div className="row">
                        <div className="col-12">
                            <RadiosEditor
                                cssWrapper="rg-150 mb-16"
                                label={"Include tax relief?"}
                                selected={
                                    this.state.isTaxReliefAvailable 
                                    ? this.props.data?.Contribution?.BedAndProductWrapperInstruction?.IsTaxRelief
                                    : false
                                }
                                options={[true, false]}
                                getText={(v) => (v ? "Yes" : "No")}
                                onChange={(v) => this.onDataChange(
                                    (changes) =>
                                        this.onDataChange(
                                            this.props.onChange,
                                            changes,
                                            this.props.data,
                                            "Contribution"
                                        ),
                                    { IsTaxRelief: v },
                                    this.props.data.Contribution,
                                    "BedAndProductWrapperInstruction"
                                )}
                                disabled={!this.state.isTaxReliefAvailable}
                                required={!this.state.isTaxReliefAvailable ? "" : "Please select include tax relief"}
                                infoText={
                                    this.props.data?.Contribution?.BedAndProductWrapperInstruction?.IsTaxRelief
                                        ? `<strong> ${MoneyDisplayHelper.FromatMoneyDisplay(
                                            (this.state.bedProductAmount || 0) * 1.25,
                                            this.props.data?.Contribution?.BedAndProductWrapperInstruction?.BedAndProductAmount?.CurrencyCode || CurrencyCode.GBP
                                        )} </strong> including tax relief (gross)`
                                        : null
                                }
                                infoTextGridClasses="pt-4"
                            />
                        </div>
                    </div>
                )}
                {
                    <>
                        {this.state.assets.length > 0 &&
                            <ChooseAssetsToSell
                                asset={this.state.assets}
                                data={data?.Contribution?.BedAndProductWrapperInstruction}
                                onChange={(v) => {
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        v,
                                        data.Contribution,
                                        "BedAndProductWrapperInstruction"
                                    );
                                }}
                                onRef={(ref) => this.appendChild(ref)}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                            />}
                        {data?.Contribution?.BedAndProductWrapperInstruction?.IsAcrossAllAssets == false &&
                            (this.state.assets.length > 0 ? (
                                <ChooseAssetsToSellTable
                                    data={data?.Contribution?.BedAndProductWrapperInstruction?.SellAllocations || []}
                                    totalValue={
                                        data?.Contribution?.BedAndProductWrapperInstruction?.BedProductAmount?.Amount ??
                                        0
                                    }
                                    tableData={this.state.assets}
                                    onRef={(ref) => this.appendChild(ref)}
                                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                    onChange={(v) => {
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                            { SellAllocations: v } as BedAndProductWrapperInstructionModel,
                                            data.Contribution,
                                            "BedAndProductWrapperInstruction"
                                        );
                                    }}
                                />
                            ) : (
                                <Alert alertType={AlertType.Warning} message={"No sellable assets"} />
                            ))}
                        <hr />
                        {
                            <PPtoProductBuyAllocation
                                data={data?.Contribution?.BedAndProductWrapperInstruction?.BuyAllocations}
                                existingAssets={this.state.assetsToBuy ?? []}
                                targetAllocations={this.state.targetAllocations ?? []}
                                onChange={(v) => {
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        v,
                                        data.Contribution,
                                        "BedAndProductWrapperInstruction"
                                    );
                                }}
                                totalValue={
                                    (data?.Contribution?.BedAndProductWrapperInstruction?.BedProductAmount?.Amount ?? 0) *
                                    (this.props.ToAbrdnSIPP && this.props.data?.Contribution?.BedAndProductWrapperInstruction?.IsTaxRelief ? 1.25 : 1)
                                }
                                sellToSubaccountType={transfertoAccountType}
                                onRef={(ref) => this.appendChild(ref)}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                isReview={this.props.isReview}
                                clientAccount={this.props.clientAccount}
                                onTreasuredAssetChange={this.onTreasuredAssetChange}
                                checkTreasuredAsset={this.state.treasuredAssetProductIds}
                                toAbrdnSIPP={this.props.ToAbrdnSIPP}
                                contributionBase={data.Contribution}
                                onDecisionMakerChange={(v)=>{
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        v,
                                        data.Contribution
                                    );
                                }}
                                modelData={{
                                    ...modelData,
                                    CashInstrument: data.CashInstrument,
                                    OwnerHierarchyId: data.OwnerHierarchyId,
                                }}
                            />
                        }
                    </>
                }
            </>
        );
    }
}
